import React from "react";
import { useNavigate } from "react-router-dom";
import { PostComposer } from "@/components/PostComposer";

export default function NewPost() {
  const navigate = useNavigate();
  return (
    <div className="space-y-5">
      <div>
        <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">New post</h1>
        <p className="text-sm text-muted-foreground mt-1">Share news, questions, or opportunities with the club.</p>
      </div>
      <PostComposer
        onPosted={() => {
          navigate("/", { replace: true });
        }}
      />
      <div className="text-xs text-muted-foreground bg-white rounded-2xl border border-border p-4">
        <div className="font-semibold text-neutral-800 mb-1.5">Posting guidelines</div>
        <ul className="list-disc pl-5 space-y-1">
          <li>Be respectful — this is a small community.</li>
          <li>Choose the right category so members can filter.</li>
          <li>Announcements are reserved for club admins.</li>
        </ul>
      </div>
    </div>
  );
}
